'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withBus = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _suber = require('suber');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var withBus = exports.withBus = function withBus(BaseComponent) {
  if (!BaseComponent) return null;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _react2.default.createElement(BaseComponent, Object.assign({}, args[0], {
      bus: (0, _suber.getBus)()
    }), args[0].children);
  };
};